module.exports = __webpack_public_path__ + "img/DESKTOPECOCONS_05_ecowater-cycle_DESKTOP.1d787d75.svg";